import React from "react";

// `image` is an optional couple-uploaded photo (presigned URL); falls back to
// the bundled default decorative image the Webflow design ships with.
const ExperienceCollectionArcFrame = ({ image }) => {
  return (
    <div
      data-w-id="426b2e63-e02b-2bed-8fa0-8e613bc5d85e"
      className="arc-frame-wrap"
    >
      <div
        data-w-id="5add24ee-bad5-55b8-ddf8-56ff776bbf3c"
        className="arc-frame"
      >
        <img
          src={image || "/assets/img/exp_002.jpg"}
          alt="Collection Room Scene"
          loading="lazy"
          className="arc-im"
        />
      </div>
    </div>
  );
};

export default ExperienceCollectionArcFrame;
